import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logoutUser } from '../../../actions/user'
import { toggle } from '../../../actions/sidebar'
import { useState } from 'react'
import { getHighestRole } from '../../../utils/utilityFuncs'
import {
  AppBar,
  Menu,
  Box,
  Toolbar,
  IconButton,
  MenuItem,
  Typography,
  Avatar,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { Logout, Settings, Menu as MenuIcon } from '@mui/icons-material'
import { MINI_WIDTH, DRAWER_WIDTH } from '../Sidebar'
import Logo from '../../Logo'

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { firstName, lastName, roles } = useSelector(state => state.auth.user) || {}
  const history = useHistory()
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { active, show } = useSelector(state => state.ui.sidebar)
  const sidebarWidth = !show || isMobile ? 0 : active ? DRAWER_WIDTH : MINI_WIDTH

  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase()
  const role = getHighestRole(roles)?.type

  const openMenu = (e) => setAnchorEl(e.currentTarget)
  const closeMenu = () => setAnchorEl(null)

  const goToMyAccount = () => {
    closeMenu()
    setTimeout(() => history.push('/my-account'), 100)
  }

  const onLogout = () => {
    dispatch(logoutUser())
    history.push('/login')
    closeMenu()
  }

  return (
    <AppBar
      position='fixed'
      elevation={0}
      sx={(theme) => ({
        backgroundColor: '#fff',
        boxShadow: '0 1px 0 0 rgba(0,0,0,0.12)',
        color: 'text.primary',
        width: `calc(100% - ${sidebarWidth}px)`,
        ml: `${sidebarWidth}px`,
        transition: theme.transitions.create(['width', 'margin-left'], {
          easing: theme.transitions.easing.sharp,
          duration: active
            ? theme.transitions.duration.enteringScreen
            : theme.transitions.duration.leavingScreen
        })
      })}
    >
      <Toolbar sx={{ height: '56px', minHeight: '56px !important', px: 2 }}>
        {isMobile && (
          <IconButton
            edge='start'
            onClick={() => dispatch(toggle(true))}
            sx={{ color: 'text.secondary', mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {!active && !isMobile && (
          <Box
            onClick={() => history.push('/')}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', mr: 1 }}
          >
            <Logo dark width='150px' height='48px' />
          </Box>
        )}

        <Box sx={{ flex: 1 }} />

        {/* User info + avatar */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ display: { xs: 'none', sm: 'block' }, textAlign: 'right' }}>
            <Typography variant='body2' sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: 13 }}>
              {firstName} {lastName}
            </Typography>
            <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'capitalize', fontSize: 11 }}>
              {role}
            </Typography>
          </Box>

          <IconButton onClick={openMenu} size='small' disableRipple>
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              {initials}
            </Avatar>
          </IconButton>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          slotProps={{ paper: { elevation: 3, sx: { mt: 1, minWidth: 200, borderRadius: 2 } } }}
        >
          <MenuItem onClick={goToMyAccount} sx={{ gap: 1.5, py: 1, fontSize: 13 }}>
            <Settings fontSize='small' sx={{ color: 'text.secondary' }} /> My Account
          </MenuItem>
          <MenuItem onClick={onLogout} sx={{ gap: 1.5, py: 1, fontSize: 13 }}>
            <Logout fontSize='small' sx={{ color: 'text.secondary' }} /> Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default Header
